export default __webpack_public_path__ + "static/jussi-841047e65c5686ea49e580f756f92cf3.png";